import articles from '@/mockData/wiki.articles.json'
import wikiService from "@/services/api/wiki.services";



const state = {
    list: articles,
}

const mutations = {
    ADD_ARTICLE(state, payload) {
        state.list.push(payload)
    }
}

const actions = {
    getArticleById(articleId) {
        return state.list.find(item => item.id == articleId)
    },
    addArticle({ commit }, form) {
        commit('ADD_ARTICLE', form)
    },

    getWiki() {
        return new Promise((resolve, reject) => {
            wikiService.get('wiki')
                .then((response) => {
                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },
// eslint-disable-next-line
    addNewPost({ commit }, payload) {
        return new Promise((resolve, reject) => {
            wikiService.post('wiki', {}, payload, {
                headers: {
                    Accept: "application/json",
                    // "Content-Type": "multipart/form-data",
                },
            }) .then(() => {
                wikiService.get('wiki')
                    .then((response) => {
                        return resolve(response)
                    })
                    .catch((error) => reject(error))
            }
            ).catch((error) => reject(error))
        })
    },

    deletePost(context, id) {
        return new Promise((resolve, reject) => {
            wikiService.delete('deletePost', id)
                .then((response) => {
                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },
// eslint-disable-next-line
    updatePost({ commit }, form) {
        return new Promise((resolve, reject) => {
            wikiService.updateTopic(
                form.id,
                form.payload
            )
                .then((response) => {return resolve(response)})
                .catch((error) => reject(error))
        })
    },
}

const getters = {
    getData: state => state.list,
    getArticleInfo: state => id => state.list.find(item => Number(item.id) === Number(id))

}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
